// extracted by mini-css-extract-plugin
export default {"slides-section":"slides_slides-section__sdeNy","slides":"slides_slides__naF1W","slide":"slides_slide__d-+eq"};